import React, {useContext} from 'react';

import {Link as RouterLink} from 'react-router-dom';

import {
    Card,
    CardContent,
    CardHeader,
    Divider,
    Grid,
    Link,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography
} from '@mui/material';


import {NavContext, NavRoutes} from "../../../contexts";
import {ComuneCompetenzaContext} from '../ComuneCompetenzaContext';

const LinkRouter = props => <Link {...props} component={RouterLink}/>;

export const StoricoList = ({
                                disabled,
                                onActionClick,
                                ...props
                            }) => {

    const {
        getRouteTo,
        navigateTo,
    } = useContext(NavContext);

    const {
        state,
        setState,
    } = useContext(ComuneCompetenzaContext);

    const {
        ufficioComuneCompetenza,
        storici,
    } = state;

    return (
        <>
            <Grid container spacing={2} sx={{marginTop: 2}}>
                <Grid item xs={12}>
                    <Card>
                        <CardHeader
                            sx={{
                                color: "white",
                                backgroundColor: "secondary.main",
                            }}
                            title={
                                <Grid container alignItems="center" justifyContent="space-between">
                                    <Grid item>
                                        <Typography variant="h6">Storici</Typography>
                                    </Grid>
                                </Grid>
                            }
                        />
                        <Divider/>
                        <CardContent sx={{padding: "0px !important"}}>
                            <Table>
                                <TableHead sx={{
                                    backgroundColor: "aliceblue",
                                }}>
                                    <TableRow>
                                        <TableCell style={{width: "30%"}}>DATA MODIFICA</TableCell>
                                        <TableCell style={{width: "70%"}}>MODIFICATO DA</TableCell>
                                        <TableCell align="right"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        storici && storici?.result?.length > 0 ?
                                            storici?.result?.map((storico, index) => <TableRow key={index}>
                                                <TableCell style={{width: "30%"}}>
                                                    <div>
                                                        <LinkRouter
                                                            color="textPrimary"
                                                            to={getRouteTo(NavRoutes.StoricoUfficioComuneCompetenza, [ufficioComuneCompetenza.comuneId, ufficioComuneCompetenza.competenzaId, storico.id])}
                                                            sx={{fontWeight: 700,}}>
                                                            {storico.dataCreazione ? storico.dataCreazione.toLocaleString("it-IT") : null}
                                                        </LinkRouter>
                                                    </div>
                                                </TableCell>
                                                <TableCell style={{width: "70%"}}>
                                                    {storico.creatoDaUtente?.nome} {storico.creatoDaUtente?.cognome}
                                                </TableCell>
                                            </TableRow>)
                                            :
                                            <TableRow>
                                                <TableCell align="center" colSpan="100%"
                                                           sx={{padding: 8, color: "primary.main", fontWeight: "bold"}}>
                                                    NON SONO PRESENTI STORICI
                                                </TableCell>
                                            </TableRow>
                                    }
                                </TableBody>
                            </Table>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </>
    );
}